:host {
  --uui-card-bg-color: var(--uui-theme-variant-100);
  --uui-card-color: var(--uui-theme-on-background);
  --uui-card-border: var(--uui-border-base);
  --uui-card-border-radius: var(--uui-border-radius-md);
  --uui-card-shaow: var(--uui-shadow-base);
  --uui-card-height: auto;
  --uui-card-max-height: none;
}

article {
  box-sizing: border-box;
  background-color: var(--uui-card-bg-color);
  color: var(--uui-card-color);
  border: var(--uui-card-border);
  border-radius: var(--uui-card-border-radius);
  height: var(--uui-card-height);
  max-height: var(--uui-card-max-height);
}

[data-mode="big"] {
  padding: var(--uui-xx-large-padding);
}

[data-mode="small"] {
  padding: var(--uui-xx-large-padding);
}

[data-mode="nopadding"] {
  padding: 0;
}